export const BASE_URL = 'organizations/'
